import "./style.css"
import {cat, files} from "./model.js"
import {formatBytes, _t, logError} from "../function.js"
import "../highlight.js"
import {mdiLink} from "@mdi/js"
/**
 * Набор иконок
 * @type {string}
 */

jqueryts.ready(() => {
    try {


        const tree_menu = []
        let height_cat = window.subgroup.length * 60
        let height_file_mn = 150
        if (document.body.offsetWidth <= 425) {
            height_file_mn = 200
        }
        if (document.body.offsetWidth < 1260) {
            height_cat = window.subgroup.length * 53
        }

        const tree_menu_conf = {
            type: "clean",
            width: 300,
            id: "tree_menu_conf",
            padding: 0,
            rows: [
                {
                    template: `<h1 class='cat_title'>${_t('Файлы')}</h1>`,
                    autoheight: true,
                    borderless: true,
                    css: (document.body.offsetWidth < 1260 && window.subgroup.length === 1) ? "mm_hide" : "",
                },
                {
                    hidden: (window.subgroup.length === 1),
                    borderless: true,
                    id: "cat_tree",
                    css: "cat_tree",
                    view: "tree",
                    height: height_cat,
                    select: true,
                    open: true,
                    data: cat,
                    scroll: false,
                    type: "lineTree",
                    template: function (obj, common) {
                        return `
                                    <div class="cat_elem">
                                        ${common.icon(obj, common)}  
                                        <span>${_t(obj.name)}</span>
                                    </div>
                                `
                    },
                    on: {
                        onBeforeClose: function () {
                            return false;
                        },
                        onAfterSelect: function (id) {
                            try {
                                cat_select(id)
                            } catch (e) {
                                logError(e)
                            }
                        },
                    }
                }
            ],
        }

        if (document.body.offsetWidth >= 1260) {
            tree_menu.push(tree_menu_conf)
            tree_menu.push({width: 60})
        } else {
            tree_menu_conf.width = 'auto'
            tree_menu_conf.hidden = true
            height_cat = window.subgroup.length * height_file_mn
            jqueryts.ui({
                container: "mm_tree_group",
                id: "download_app",
                hidden: true,
                align: "left",
                padding: 0,
                body: tree_menu_conf
            })

        }
        tree_menu.push({
            width: 1,
            borderless: true,
        })
        tree_menu.push({
            width: 1,
            borderless: false,
        })

        function file_href(obj) {
            switch (obj.id_type) {
                case 1:
                    return `<a style="width: 150px" class="v-btn v-btn--is-elevated v-btn--has-bg v-btn--rounded v-btn--router theme--light v-size--default primary" 
                                href="${obj.url}" download="${obj.name}.${obj.ext}">${_t('Скачать')}</a>`
                case 2:
                    return `<a style="width: 150px" class="v-btn v-btn--is-elevated v-btn--has-bg v-btn--rounded v-btn--router theme--light v-size--default primary" 
                                href="${obj.link}">${_t('Ссылка')}</a>`
                case 3:
                    return `
<a style="width: 150px" class="v-btn v-btn--is-elevated v-btn--has-bg v-btn--rounded v-btn--router theme--light v-size--default primary" 
                                href="${obj.link}" target="_blank">${_t('Онлайн')}</a>
<a style="width: 150px" class="v-btn v-btn--is-elevated v-btn--has-bg v-btn--rounded v-btn--router theme--light v-size--default primary" 
                                href="${obj.url}" download="${obj.name}.${obj.ext}">${_t('Скачать')}</a>
`

            }
            return ``
        }

        function file_img(obj) {
            switch (obj.id_type) {
                case 1:
                    return `<div class="cat_file_img"><div></div></div>`
                case 2:
                    return `<div class="cat_link_img"><div></div></div>`
                case 3:
                    return `<div class="cat_file_img"><div></div></div>`
            }
            return ``
        }

        function file_desc(obj) {
            try {
                const data = `
<div class="cat_file_info row">
    <div class="col col-5">
        <div class="rcenter">
            <div class="cat_file_info_elem">
            ${_t('Файл')}: <b>${obj.ext}</b>
            </div>
        </div>
    </div>
    <div class="col col-7">
        <div class="rcenter">
            <div class="cat_file_info_elem">
            ${_t('Размер')}: <b>${formatBytes(obj.size)}</b>
            </div>
        </div>
    </div>
</div>
`
                switch (obj.id_type) {
                    case 1:
                        return data
                    case 2:
                        return ``
                    case 3:
                        return data
                }
                return ``
            } catch (e) {
                logError(e)
            }
        }

        tree_menu.push(
            {
                css: "cat_file_block",
                rows:
                    [
                        {
                            view: "datatable",
                            css: "cat_file",
                            id: "cat_file",
                            data: files,
                            select: false,
                            scroll: false,
                            header: false,
                            borderless: false,
                            fixedRowHeight: false,
                            rowLineHeight: 20,
                            rowHeight: 20,
                            autoheight: true,
                            columns: [
                                {
                                    id: 'desc',
                                    fillspace: true,
                                    template: (obj) => {
                                        let file_img_data = ``
                                        file_img_data = file_img(obj)

                                        let file_href_data = ''
                                        file_href_data = file_href(obj)
                                        return `
                            <div class="cat_file row" style="align-content: center">
                                <div class="col-lg-1 col-md-hide col-sm-hide">
                                    <div class="rcenter" style="align-items: center">
                                        ${file_img_data}
                                    </div>
                                </div>
                                <div class="col-lg-11 col-md-12  col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6">
                                            <div class="cat_file_desc rcenter">
                                                <span class="cat_file_title">${_t(obj.name)}</span>
                                                <span class="cat_file_text">${_t(obj.desc)}</span>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6">
                                            ${file_desc(obj)}
                                        </div>
                                        <div class="col-lg-3 col-md-12">
                                            <div class="rcenter" style="align-items:flex-end">
                                                <div class="cat_file_href">
                                                    ${file_href_data}
                                                </div>
                                            </div>
                                        </div>
                                          
                                    </div>
                                </div>
                                
                            </div>
                        `
                                    },
                                },
                            ],
                            on: {
                                onAfterRender: () => {
                                    $(`.cat_file`).find('.jqueryts_cell').each((key, el) => {
                                        $(el).on('mouseover', function (e) {
                                            $(`.cat_file`).find('.jqueryts_cell').removeClass('cell_hover');
                                            var rowid = $(this).attr('aria-rowindex');
                                            $(`.cat_file`).find(`.jqueryts_cell[aria-rowindex="${rowid}"]`).addClass('cell_hover');
                                        })
                                    })
                                }
                            },
                            ready: function () {
                            },
                        },
                        {
                            id: "cat_allow_auth",
                            template: `#mess#`,
                            data: {
                                mess: `...`
                            },
                            autoheight: true
                        }
                    ]
            }
        )

        jqueryts.ui({
            container: "download_app",
            id: "download_app",
            align: "left",
            body: {
                rows: [
                    {
                        type: "clean",
                        width: $("#download_app").width(),
                        autoheight: true,
                        id: "cols_download",
                        cols: tree_menu
                    }
                ]
            },

        })

        function cat_select(id) {
            try {
                id = parseInt(id)
                const cat_elem = cat.getItem(id)
                if (cat_elem.allow !== true) {
                    $$("cat_file").hide()
                    $$("cat_allow_auth").setValues({mess: cat_elem.allow})
                    $$("cat_allow_auth").show()
                    hideProgress()
                    return false
                }
                $$("cat_allow_auth").hide()
                $$("cat_file").show()
                files.filter(el => {
                    return el.id_cat == id
                })
                if (cat_elem.link === "center") {
                    files.filter()
                }

                $$("cat_file").resize()
                $$("cat_file").refresh()
                $('#mm_close').click()
                cat_elem.files_sort.map(el => {
                    if (el.id_file === null) return false;
                    const file = files.getItem(el.id_file)
                    file.cat_sorting = el.sort
                    files.updateItem(el.id_file, file)
                })
                if (cat_elem.id === 3) {
                    $$("cat_file").sort({
                        as: "int",
                        dir: "asc",
                        by: "sort"
                    })
                } else {
                    $$("cat_file").sort({
                        as: "int",
                        dir: "asc",
                        by: "cat_sorting"
                    })
                }
                $$("cat_file").adjustRowHeight('desc', false)
                let height = 0
                let height_file = $$("cat_file").config.height

                if (document.body.offsetWidth > 1260) {
                    height = (height_file > height_cat) ? height_file : height_cat;
                } else {
                    height = height_file
                }
                $$("cols_download").define("height", height + 2)
                $$("cols_download").resize()
                $("#download_app").height(height)
                hideProgress()


            } catch (e) {
                logError(e)
            }
        }

        function hideProgress() {
            setTimeout(() => {
                $(".download_load").hide()
                $("#download_app").css("opacity", "1")
            }, 300)
        }


        document.addEventListener('DOMContentLoaded', (event) => {
            $$("cat_tree").select(window.subgroup_action)
        });

        setTimeout(() => {
            $$("cat_tree").select(window.subgroup_action)
        }, 200)
    } catch (e) {
        logError(e)
    }
})

window.addEventListener('resize', function () {
    try {
        $$("cols_download").define("width", $("#download_app").width())
        $$("cols_download").resize()
        $$("cat_file").resize()
        $$("download_app").resize()
        $$("cat_file").refresh()

        if (document.body.offsetWidth >= 1259) {
            $$("cat_file").showColumn('icon')
            $$("cat_file").showColumn('link')
        } else {
            $$("cat_file").hideColumn('icon')
            $$("cat_file").hideColumn('link')
        }

        $$("cat_file").refreshColumns();
        $$("cat_file").adjustRowHeight('desc', null)
    } catch (e) {
        logError(e)
    }
})